import { CommonModule, IMAGE_CONFIG } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ContentService } from '@services/content.service';
import { NavService } from '@services/nav.service';

import { overlayAnimations } from './loading-overlay.animation';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'bk-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  animations: overlayAnimations,

  providers: [
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    },
  ],
})
export class LoadingOverlayComponent {
  navService = inject(NavService);
  contentService = inject(ContentService);

  isLoading = toSignal(this.navService.showLoading$);
  loadingImage = this.contentService.getLoginImage();
  loading = this.contentService.texts.common.loading;
  image = signal<string | null>('');
  error = false;

  handleLoad() {
    setTimeout(() => {
      this.image.set(this.loadingImage);
    }, 1);
    setTimeout(() => {
      this.navService.showLoading$.next(false);
    }, 4500);
  }

  handleError() {
    this.error = true;
    this.image.set('/assets/fallback.jpg');
  }

  closeOverlay() {
    this.navService.showLoading$.next(false);
  }
}
